export function getShortCodeHelpers(pathname: string) {
  function getShortCode(): string | null {
    const match = pathname?.match(/^\/r\/(.+)/);

    return match ? match[1] : null;
  }

  return {
    get isShortCode() {
      return !!getShortCode();
    },
    get shortCode() {
      return getShortCode();
    },
  };
}
